import React, { useState } from "react";
import { Navbar, NavbarBrand, Nav, NavItem, NavLink, NavbarToggler, Collapse } from "reactstrap";
import LanguageDropdown from "../CommonForBoth/TopbarDropdown/LanguageDropdown";
import { BRAND_LOGO_LIGHT_BG } from "../../constants/branding";
import withRouter from "../Common/withRouter";

const CustomHeader = (props) => {
  const [isOpen, setIsOpen] = useState(false);

  // ✅ pathname is lowercased: `pathname`, not `pathName`
  const currentPath = props.router.location.pathname;
  const searchParams = new URLSearchParams(props.router.location.search);
  const role = searchParams.get("role");

  const routeLstForLangugaeSupport = [
    "work-interest",
    "worker-onboarding",
    "worker-submit-agreement"
  ];

  // ✅ Special check for verify-otp with role=worker
  const showLangugaeDropdown =
    routeLstForLangugaeSupport.some((r) => currentPath.includes(r)) ||
    (currentPath.includes("verify-otp") && role === "worker");

  const toggle = () => setIsOpen(!isOpen);

  return (
    <Navbar
      expand="md"
      light
      className="bg-white border-bottom shadow-sm px-3 px-md-4 py-2 py-md-3"
    >
      <NavbarBrand href="https://www.jobark.co.uk" className="p-0">
        <img src={BRAND_LOGO_LIGHT_BG} alt="JobArk" height="36" />
      </NavbarBrand>
      <NavbarToggler onClick={toggle} className="border-0">
        <i className={`bx ${isOpen ? "bx-x" : "bx-menu"} fs-3 text-dark`}></i>
      </NavbarToggler>
      <Collapse isOpen={isOpen} navbar>
        <Nav className="ms-auto align-items-center" navbar>
          <NavItem>
            <NavLink
              href="https://www.jobark.co.uk"
              className="fs-5 fs-md-5 px-2 px-md-3 py-2 py-md-1 text-dark"
            >
              Home
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              href="https://www.jobark.co.uk/about-us"
              className="fs-5 fs-md-5 px-2 px-md-3 py-2 py-md-1 text-dark"
            >
              About Us
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              href="https://www.jobark.co.uk/contact-us"
              className="fs-5 fs-md-5 px-2 px-md-3 py-2 py-md-1 text-dark"
            >
              Contact
            </NavLink>
          </NavItem>
          {showLangugaeDropdown && (
            <NavItem className="py-2 py-md-0">
              <LanguageDropdown />
            </NavItem>
          )}
        </Nav>
      </Collapse>
    </Navbar>
  );
};

export default withRouter(CustomHeader);
